function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { IcIcon } from './../../../index.js';
import PropTypes from 'prop-types';
import NavLinkButton from './NavLinkButton';
import { UilSearch } from "@iconscout/react-unicons";
var NavLinkWithIcon = function NavLinkWithIcon(_ref) {
    var icon = _ref.icon,
        children = _ref.children,
        rest = _objectWithoutProperties(_ref, ['icon', 'children']);

    return React.createElement(
        NavLinkButton,
        rest,
        React.createElement(IcIcon, { icon: icon, className: 'mr-2' }),
        children
    );
};

NavLinkWithIcon.defaultProps = {
    icon: UilSearch,
    children: "button"
};
NavLinkWithIcon.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
    * fontawesome icon name
    */
    icon: PropTypes.string.isRequired,
    /**
     * Button children (same as react bootstrap properties)
     */
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired
} : {};

export default NavLinkWithIcon;